import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FloatModal, Modal } from '@/lib/components/Modal';
import { closeModal } from '@/lib/components/Modal/Modal';
import { Button, Select, Text } from '@/lib/v2/components';
import { Flex } from '@/lib/v2/components/Layout/Stack';
import { Option } from '@/lib/v2/components/Select/Select';

type FormInput = {
  flows: Option;
};
/* eslint-disable @typescript-eslint/no-explicit-any */
export const ContactsToFlowModal = ({ itemList, setConfirmToFlow, setFlowId }: any) => {
  const { t } = useTranslation();
  let statusFlows = true;

  try {
    itemList = JSON.parse(itemList);
  } catch {
    statusFlows = false;
  }

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormInput>();

  const RULES = {
    flows: {
      required: t('MANAGE_TAG_MODAL.emptyField'),
    },
    onActionCreate: (value: FormInput) => {
      setFlowId(value.flows.id);
      setConfirmToFlow(true);
      closeModal();
    },
  };

  const onAction = handleSubmit((values: FormInput) => {
    RULES.onActionCreate(values);
  });

  return (
    <FloatModal>
      <Modal>
        <div className="p-6">
          <Modal.Title onAction={() => closeModal()}>
            <Text color="light-black" variant="headline">
              {t('CONTACT_FLOW_MODAL.title')}
            </Text>
          </Modal.Title>
          <Modal.Body>
            {statusFlows ? (
              <div className="w-[35rem] py-[5%]">{t('CONTACT_FLOW_MODAL.description')}</div>
            ) : (
              <div className="w-[35rem] py-[5%]">{t('CONTACT_FLOW_MODAL.error')}</div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Flex withGap alignment="start" gapSize="medium">
              {statusFlows && (
                <>
                  <div className="mt-4">
                    <Button onClick={onAction}>
                      <div className="text-12 lg:text-12 xl:text-14 2xl:text-16">
                        {t('CONTACT_FLOW_MODAL.sendTo')}
                      </div>
                    </Button>
                  </div>
                  <div className="mt-1 h-[34px] w-[42%]">
                    <Select control={control} name="flows" options={itemList} rules={RULES.flows} />
                  </div>
                </>
              )}
            </Flex>
          </Modal.Footer>
        </div>
      </Modal>
    </FloatModal>
  );
};
